import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

const addressAtom = atom<string>({
    default: "",
    key: "address",
});

export const useAddress = () => useRecoilState(addressAtom);
export const useSetAddress = () => useSetRecoilState(addressAtom);
export const useAddressValue = () => useRecoilValue(addressAtom);
